import { PatientDependent } from "./patientDependent";

export class PatientInsuranceDetail {
  id: number;
  patientId: number;
  insurancePlanFrontPictureUrl: string;
  insurancePlanBackPictureUrl: string;
  active: boolean;
  insurancePlanId: number | null;
  insurancePlanPayerId: string;
  insuranceType: string;
  memberFullName: string;
  memberId: string;
  groupNumber: string;
  insuranceValidFrom: Date;
  insuranceValidTo: Date;
  payerId: number | null;
  healthPlanNo: string;
  pokitDokId: string;
  insurancePlanName: string;
  companyName: string;
  category: number;
  hasHSA: boolean;
  hasFSA: boolean;
  dependents: PatientDependent[]

}
